import { Col, Container, Input, Row } from "reactstrap";
import DepartmentSapParameter from "../../../../../backoffice/dtos/groups/DepartmentSapParameter";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Group } from "../../../../../backoffice/dtos/groups/group";

export default function DepartmentsSapParameterEdit(
    {
        isOpen,
        toggle,
        errors,
        group,
        sapParameters,
        setSapParameters
    }: {
        isOpen: boolean;
        toggle: () => void;
        errors: Map<string, string> | undefined;
        group: Group,
        sapParameters: DepartmentSapParameter[];
        setSapParameters: (sapParametersFunc: (sapParameters: DepartmentSapParameter[]) => DepartmentSapParameter[]) => void;
    }
) {
    const {t} = useTranslation(['department_info','common'])

    const onGlChange = useCallback((e: any) => {
        setSapParameters(ref => {
            let item = ref.find(m => m.fieldName === e.target.name);
            ref = ref.filter(m => m.fieldName !== e.target.name);

            if (item) {
                item.value = e.target.value;

                return [...ref, item]
            } else {
                item = {
                    groupId: group.id,
                    fieldName: e.target.name,
                    value: e.target.value
                }
                return [...ref, item]
            }
        });
    }, [setSapParameters]);

    const fields = useMemo(() => {
        const type: any = {}
        if (sapParameters === undefined) {
            return type;
        }
        for(const item of sapParameters) {
            type[item.fieldName] = item.value;
        }
        return type;
    }, [sapParameters])

    return (
        <Container>
            <Row className="gy-1">
                <Col lg={5} className="d-flex align-items-center justify-content-end">
                    {t('GL Account')}*
                </Col>
                <Col>
                    <Input type="text" id="GLAccount" name="GLAccount" onChange={onGlChange} value={fields.GLAccount}/>
                    {
                        errors && errors.has("GLAccount") && <span className="text-danger">{errors.get("GLAccount")}</span>
                    }
                </Col>
            </Row>
        </Container>
    );
}